module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/my-848fbf91865a8d1912638bb1c2b8fa0a.svg";